
export default [
    {
        name: "dotEasyHome",
        path: "/easy",
        component: () => import(/* webpackChunkName: "dot-easy-home" */ /* webpackPrefetch: true */ "@/view/easy/DotEasyHome.vue"),
        meta: {
            layout: "BlankLayout",
            title: "Dot Easy Apps : Dot Easy Home",
            auth: false,
        },
    },
    {
        name: "dotEasyCloud",
        path: "/easy/cloud",
        component: () => import(/* webpackChunkName: "dot-easy-cloud" */ /* webpackPrefetch: true */ "@/view/easy/DotEasyCloud.vue"),
        meta: {
            layout: "EasyCloudLayout",
            title: "Dot Easy Apps : Dot Easy Cloud",
        },
    },
    {
        name: "dotEasySearch",
        path: "/easy/search",
        component: () => import(/* webpackChunkName: "dot-easy-search" */ /* webpackPrefetch: true */ "@/view/easy/DotEasySearch.vue"),
        meta: {
            layout: "EasyCloudLayout",
            title: "Dot Easy Apps : Dot Easy Search",
        },
    },
    {
        name: "dotEasyTactile",
        path: "/easy/tactile",
        component: () => import(/* webpackChunkName: "dot-easy-tactile" */ /* webpackPrefetch: true */ "@/view/easy/DotEasyTactile.vue"),
        meta: {
            layout: "BlankLayout",
            title: "Dot Easy Apps : Dot Easy Tactile",
        },
    },
    //todo: canvas, image 는 동일한 화면 layout 을 공유함으로 차후에 합칠 예정
    {
        name: "dotEasyCanvas",
        path: "/easy/canvas",
        component: () => import(/* webpackChunkName: "dot-easy-canvas" */ /* webpackPrefetch: true */ "@/view/easy/DotEasyCanvas.vue"),
        meta: {
            layout: "BlankLayout",
            title: "Dot Easy Apps : Dot Easy Editor (Canvas)",
        },
    }
]